'use strict';

angular.module('youth').controller('YouthGetHelpCtrl', ['$scope', '$sce', 'userSvc', 'providerSvc', function ($scope, $sce, userSvc, providerSvc) {
  var vm = this;
  vm.cobrandingText = '';
  userSvc.getUser().then(function (user) {
    if (user && user.organization) {
      vm.cobrandingText = user.organization.name;
      providerSvc.getHeaderImage().then(function (data) {
        if (data) {
          vm.cobranding = data;
        }
      });
    } else {
      vm.cobrandingText = '';
    }
    providerSvc.getPreferences().then(function (prefs) {
      if (prefs && prefs.getHelpText) {
        vm.getHelpText = $sce.trustAsHtml(prefs.getHelpText);
      }
    });
  });
}]);